/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-09-13 15:19:26
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-02 10:37:59
 */
import request from '@/utils/request'
import type * as common from '@/typings/common'

export async function queryTaskList(params?: common.TableListParams) {
  return request('/api/myTask/list', {
    method: 'POST',
    data: params
  })
}

interface GetTaskListRequest {
  content?: string
  executor_list?: string[]
  finished?: number
  is_all?: string
  page?: number
  priority?: number
  size?: number
  time_sort_rule?: number
  type?: number
}
// (新版)任务列表（我的任务列表公用此接口）
export async function getTaskList(params: GetTaskListRequest) {
  return request('/api/v2/interact/task_search', {
    method: 'post',
    data: params
  })
}

interface TaskFinishRequest {
  ids: number[]
}
// (新版)任务完成（批量完成共用此接口）
export async function taskFinish(params: TaskFinishRequest) {
  return request('/api/v2/interact/task_finish', {
    method: 'post',
    data: params
  })
}

interface TaskDetaileRequest {
  id: number
}
// 任务详情
export async function taskDetail(params: TaskDetaileRequest) {
  return request('/api/v2/interact/task_detail', {
    method: 'GET',
    params
  })
}

interface TaskSaveRequest {
  priority: number
  deadline: number
  executor_id: number
  content: string
}
// (新版)保存任务
export async function taskSaveV2(params: TaskSaveRequest) {
  return request('/api/v2/interact/task_save', {
    method: 'post',
    data: params
  })
}

interface TaskRestartRequest {
  id: number
  deadline: number
  executor_id: number
}
// (新版)任务重做
export async function taskRestartV2(params: TaskRestartRequest) {
  return request('/api/v2/interact/task_restart', {
    method: 'post',
    data: params
  })
}

interface TaskRestartRequest {
  id: number
  remind_time: number
}
// 任务提醒
export async function taskRemind(params: TaskRestartRequest) {
  return request('/api/v2/interact/task_remind', {
    method: 'post',
    data: params
  })
}
